// extracted by mini-css-extract-plugin
export default {"root":"ProvidedRowContainer-root_pEA0V","domainProductDescription":"ProvidedRowContainer-domainProductDescription_VmbvI"};